import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { slugify } from '@finect/front-utils/slugify';
export var processTag = function processTag(tag) {
  var id = tag.id,
    name = tag.name,
    description = tag.description,
    icon = tag.icon,
    image = tag.image,
    stats = tag.stats;
  return {
    id: id,
    name: name,
    alias: slugify(name),
    icon: icon,
    image: image,
    tagline: description && description !== name ? description : '',
    followers: stats.subscribers
  };
};